import { render, staticRenderFns } from "./AtreemoSettings.vue?vue&type=template&id=50326afe"
import script from "./AtreemoSettings.vue?vue&type=script&lang=js"
export * from "./AtreemoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports